import { createFileRoute, Link } from "@tanstack/react-router";
import { AppShell } from "@/components/app-shell";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Shield } from "lucide-react";

export const Route = createFileRoute("/solutionists")({
  head: () => ({ meta: [{ title: "Xamseen — Solutionists" }] }),
  component: SolutionistsPage,
});

function SolutionistsPage() {
  const [users, setUsers] = useState<any[]>([]);
  useEffect(() => {
    supabase.from("profiles").select("id,username,full_name,avatar_url,bio,location,reputation_points,impact_score")
      .order("impact_score", { ascending: false }).order("reputation_points", { ascending: false }).limit(40)
      .then(({ data }) => setUsers(data ?? []));
  }, []);

  return (
    <AppShell>
      <div className="mx-auto max-w-5xl space-y-6">
        <header>
          <h1 className="font-display text-3xl font-semibold tracking-tight">Solutionist Network</h1>
          <p className="text-muted-foreground">Verified problem-solvers with track records in their communities.</p>
        </header>
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {users.map((u) => (
            <Link key={u.id} to="/profile/$username" params={{ username: u.username }}>
              <Card className="p-5 hover:bg-accent/40">
                <div className="flex items-center gap-3">
                  <Avatar className="h-12 w-12"><AvatarImage src={u.avatar_url ?? undefined} /><AvatarFallback>{(u.full_name || u.username)[0]}</AvatarFallback></Avatar>
                  <div className="min-w-0">
                    <div className="flex items-center gap-1 font-semibold">{u.full_name || u.username} <Shield className="h-3.5 w-3.5 text-secondary" /></div>
                    <div className="truncate text-xs text-muted-foreground">@{u.username}{u.location ? ` · ${u.location}` : ""}</div>
                  </div>
                </div>
                {u.bio && <p className="mt-3 text-sm text-muted-foreground line-clamp-2">{u.bio}</p>}
                <div className="mt-3 flex gap-2">
                  <Badge variant="secondary">{u.reputation_points} rep</Badge>
                  <Badge variant="outline">{u.impact_score ?? 0} impact</Badge>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </AppShell>
  );
}
